import React from "react";
import YouTubeGallery from "@/components/YouTubeGallery";
import CommentSection from "@/components/CommentSection";

export default function Podcasts() {
  return (
    <div data-testid="podcasts-page">
      <div className="px-6 md:px-12 lg:px-16 pt-16 pb-8 bg-halo-navy text-halo-cream">
        <div className="text-halo-red font-sports uppercase tracking-[0.3em] text-xs mb-3">Episode Archive</div>
        <h1 className="font-sports uppercase tracking-tight leading-none text-5xl sm:text-6xl lg:text-7xl">
          Every Episode. <span className="text-halo-red">Every Postgame.</span>
        </h1>
        <p className="mt-5 font-body text-halo-cream/70 max-w-2xl">
          Pulled live from our YouTube channel. New episodes appear automatically after every Angels game.
        </p>
      </div>
      <YouTubeGallery limit={24} showTitle={false} />
      <CommentSection targetType="general" targetId="podcasts-feed" title="Episode Talk" />
    </div>
  );
}
